<jmkw-popout-button
  #viewToggleButton
  [iconName]="iconName"
  [contentComponent]="componentRef"
  tooltipText="Toggle Map Views"
></jmkw-popout-button>
